export const agGridStyle = {
  wrapperCellStatus: {
    height: "40px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: "0 8px",
  },
  wrapperCell: {
    height: "40px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
};

export const approvalCellStyle = {
  button: {
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "14px",
    paddingLeft: "3px",
  },
  timeIcon: {
    marginRight: "2px",
  },
  approvedWrapper: {
    display: "flex",
    alignItems: "center",
  },
  checkIcon: {
    marginRight: "10px",
    color: "green",
    fontSize: "20px",
  },
  checkText: {
    fontSize: "14px",
    fontWeight:'bold'
  },
  blockIcon: {
    marginRight: "10px",
    color: "red",
    fontSize: "20px",
  },
};

export const documentsCellStyle = {
  wrapper: {
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    width: "24px",
    height: "24px",
  },
};

export const statusCellStyle = {
  chip: {
    color: "white",
    width: "100%",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "11px",
    maxHeight: "24px",
  },
};

export const tripCardStyle = {
  card: {
    padding: "8px 16px",
    margin: "8px 16px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
    minWidth: "350px",
  },
  box: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  tripID: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "16px",
  },
  mainBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  mainText: {
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  valueText: {
    fontSize: "14px",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    padding: "8px",
    borderRadius: "8px",
    marginTop: "8px",
  },
  box3: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    maxWidth: 134,
  },
  box4: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    maxWidth: 134,
  },
  box5: {
    maxWidth: "120px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    textTransform: "none",
    textDecoration: "underline",
    fontWeight: "bold",
  },
};
